module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/index.js");
  /******/
}
/************************************************************************/

/******/
({
  /***/
  "./icons/LocationIcon.js":
  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var LocationIcon = function LocationIcon() {
      return /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        focusable: "false",
        "aria-hidden": "true"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fill: "#00AED9"
      }));
    };

    var _default = LocationIcon;
    exports.default = _default;
    /***/
  },

  /***/
  "./icons/PencilIcon.js":
  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var PencilIcon = function PencilIcon() {
      return /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
      }, /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8218 0.621859L15.362 2.16167C16.2127 3.016 16.2127 4.39698 15.362 5.2513L5.55074 15.0701L0 16L0.930123 10.4407L10.7314 0.621859C11.5946 -0.207286 12.9586 -0.207286 13.8218 0.621859ZM9.8014 3.73047L2.72046 10.8096L5.19079 13.2693L12.2617 6.19017L9.8014 3.73047ZM2.15039 12.4023L3.59058 13.8522L1.86035 14.1321L2.15039 12.4023ZM13.3418 5.16131L14.2819 4.16143C14.406 4.04261 14.4762 3.87827 14.4762 3.70649C14.4762 3.5347 14.406 3.37036 14.2819 3.25154L12.7317 1.70173C12.4789 1.45402 12.0743 1.45402 11.8216 1.70173L10.8814 2.64161L13.3418 5.16131Z",
        fill: "#00AED9"
      }));
    };

    var _default = PencilIcon;
    exports.default = _default;
    /***/
  },

  /***/
  "./src/DeliveryCard.js":
  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _Secondary = _interopRequireDefault(__webpack_require__("@carvana/showroom-forms/Button/Secondary"));

    var _fecha = _interopRequireDefault(__webpack_require__("fecha"));

    var _DeliveryOrPickup = __webpack_require__("./src/DeliveryOrPickup.styles.tsx");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var DeliveryCard = function DeliveryCard(_ref) {
      var deliveryAndPickupDetails = _ref.deliveryAndPickupDetails,
          isFetchingDeliveryAndPickupDetails = _ref.isFetchingDeliveryAndPickupDetails,
          env = _ref.env;

      var getFastlyBaseUrl = function getFastlyBaseUrl(environment) {
        switch (environment) {
          case 'development':
            return 'https://assets.fastly.zagforward.com';

          case 'test':
            return 'https://assets.fastly.carvanatech.com';

          case 'uat':
            return 'https://resources.fastly.cvuat.com';

          case 'production':
            return 'https://assets.fastly.carvana.io';

          default:
            return 'https://assets.fastly.carvana.io';
        }
      };

      var isDeliveryAndPickupDetailsFetched = Object.keys(deliveryAndPickupDetails).length;
      var CDN_BASE_URL = "" + getFastlyBaseUrl(env);
      var soonestDeliveryAvailable = deliveryAndPickupDetails.soonestDeliveryAvailable;

      var _ref2 = soonestDeliveryAvailable || false,
          isThirdPartyDelivery = _ref2.isThirdPartyDelivery;

      var learnMorelink = isThirdPartyDelivery ? '/help/pickup-and-delivery/what-is-the-process-for-my-out-of-market-carvana-delivery' : '/help/pickup-and-delivery/what-happens-at-delivery';

      var renderDeliveryWithData = function renderDeliveryWithData() {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupHeader, null, "Delivery as soon as:"), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupTimeWrapper, null, /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupImage, {
          src: CDN_BASE_URL + "/about-assets/delivery.png?format=jpeg&auto=webp"
        }), isThirdPartyDelivery ? /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupDate, {
          className: "is-out-of-market"
        }, /*#__PURE__*/_react.default.createElement("div", null, "business days after purchase"), /*#__PURE__*/_react.default.createElement("div", null, "5-15")) : /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupDate, null, /*#__PURE__*/_react.default.createElement("div", null, _fecha.default.format(new Date(soonestDeliveryAvailable.date), 'MMMM')), /*#__PURE__*/_react.default.createElement("div", null, _fecha.default.format(new Date(soonestDeliveryAvailable.date), 'D')))), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LineBreaker, null), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupLocation, null, /*#__PURE__*/_react.default.createElement("span", null, "Deliver to:"), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LocationText, null, soonestDeliveryAvailable.city, ", ", soonestDeliveryAvailable.state)), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LearnMoreButtonWrapper, {
          href: learnMorelink
        }, /*#__PURE__*/_react.default.createElement(_Secondary.default, {
          size: "medium"
        }, "Learn More")));
      };

      var renderDeliveryWithSadState = function renderDeliveryWithSadState() {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupTimeWrapper, {
          className: "is-sad-state"
        }, /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupImage, {
          src: CDN_BASE_URL + "/about-assets/delivery.png?format=jpeg&auto=webp",
          className: "is-sad-state"
        }), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LineBreaker, null), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupHeader, {
          className: "is-sad-state"
        }, "Delivery"), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LearnMoreButtonWrapper, {
          href: learnMorelink
        }, /*#__PURE__*/_react.default.createElement(_Secondary.default, {
          size: "medium"
        }, "Learn More"))), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryCardCaption, null));
      };

      var renderDeliveryCard = function renderDeliveryCard() {
        if (isDeliveryAndPickupDetailsFetched) {
          return renderDeliveryWithData();
        }

        return renderDeliveryWithSadState();
      };

      return /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupCardWrapper, null, isFetchingDeliveryAndPickupDetails ? /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LoadingSpinner, {
        isLarge: true
      }) : renderDeliveryCard());
    };

    var _default = DeliveryCard;
    exports.default = _default;
    /***/
  },

  /***/
  "./src/DeliveryOrPickup.styles.tsx":
  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.LoadingSpinner = exports.UserlocationText = exports.UserlocationTextWrapper = exports.DeliveryCardCaption = exports.LineBreaker = exports.LearnMoreButtonWrapper = exports.LocationText = exports.DeliveryPickupLocation = exports.DeliveryPickupDate = exports.DeliveryPickupImage = exports.DeliveryPickupTimeWrapper = exports.DeliveryPickupHeader = exports.DeliveryPickupCardWrapper = exports.DeliveryPickupCardContainer = exports.DeliveryOrPickupWrapper = void 0;

    var _styledComponents = _interopRequireDefault(__webpack_require__("styled-components"));

    var _showroomSpinner = _interopRequireDefault(__webpack_require__("@carvana/showroom-spinner"));

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var DeliveryOrPickupWrapper = _styledComponents.default.div.withConfig({
      displayName: "DeliveryOrPickupWrapper",
      componentId: "gsi14k-0"
    })(["width:100%;"]);

    exports.DeliveryOrPickupWrapper = DeliveryOrPickupWrapper;

    var DeliveryPickupCardContainer = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupCardContainer",
      componentId: "gsi14k-1"
    })(["display:flex;position:relative;flex-direction:column;@media (min-width:", "px){flex-direction:row;}"], function (props) {
      return props.theme.breakpoint.md;
    });

    exports.DeliveryPickupCardContainer = DeliveryPickupCardContainer;

    var DeliveryPickupCardWrapper = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupCardWrapper",
      componentId: "gsi14k-2"
    })(["width:100%;background:", ";border:1px solid ", ";box-sizing:border-box;box-shadow:0px 6px 13px rgba(24,53,88,0.1);border-radius:8px;min-height:383px;display:flex;flex-direction:column;justify-content:center;margin-bottom:0;padding:0 40px;@media (min-width:", "px){margin-bottom:35px;}&:first-child{margin-right:16px;}"], function (props) {
      return props.theme.color.neutral.v100;
    }, function (props) {
      return props.theme.color.neutral.v300;
    }, function (props) {
      return props.theme.breakpoint.md;
    });

    exports.DeliveryPickupCardWrapper = DeliveryPickupCardWrapper;

    var DeliveryPickupHeader = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupHeader",
      componentId: "gsi14k-3"
    })(["font-size:16px;line-height:24px;text-align:center;font-feature-settings:'liga' off;color:", ";padding:40px;padding-bottom:24px;margin-right:0 !important;&.is-sad-state{color:", ";font-weight:bold;font-size:16px;line-height:18px;padding:0;}"], function (props) {
      return props.theme.color.neutral.v500;
    }, function (props) {
      return props.theme.color.primary.v600;
    });

    exports.DeliveryPickupHeader = DeliveryPickupHeader;

    var DeliveryPickupTimeWrapper = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupTimeWrapper",
      componentId: "gsi14k-4"
    })(["display:flex;justify-content:center;&.is-sad-state{flex-direction:column;align-items:center;}"]);

    exports.DeliveryPickupTimeWrapper = DeliveryPickupTimeWrapper;

    var DeliveryPickupImage = _styledComponents.default.img.withConfig({
      displayName: "DeliveryPickupImage",
      componentId: "gsi14k-5"
    })(["height:104px;width:104px;border-radius:100%;margin-right:39px;@media (min-width:", "px){margin-right:55px;}@media (min-width:", "px){margin-right:43px;}&.is-sad-state{height:216px;width:216px;margin:40px 0 0 0;}"], function (props) {
      return props.theme.breakpoint.md;
    }, function (props) {
      return props.theme.breakpoint.lg;
    });

    exports.DeliveryPickupImage = DeliveryPickupImage;

    var DeliveryPickupDate = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupDate",
      componentId: "gsi14k-6"
    })(["height:104px;width:104px;background:", ";border-radius:3px;text-align:center;&.is-out-of-market{display:flex;flex-direction:column-reverse;justify-content:center;div:first-child{padding:3px 6px;font-weight:normal;font-size:12px;line-height:16px;text-transform:lowercase;}}div:first-child{font-weight:bold;margin:0;padding-top:16px;padding-bottom:8px;font-size:14px;line-height:16px;text-align:center;text-transform:uppercase;font-feature-settings:'cpsp' on,'liga' off;color:", ";}div:last-child{font-weight:bold;font-size:40px;line-height:40px;text-align:center;text-transform:uppercase;font-feature-settings:'cpsp' on,'liga' off;color:", ";}"], function (props) {
      return props.theme.color.neutral.v200;
    }, function (props) {
      return props.theme.color.primary.v600;
    }, function (props) {
      return props.theme.color.neutral.v400;
    });

    exports.DeliveryPickupDate = DeliveryPickupDate;

    var DeliveryPickupLocation = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupLocation",
      componentId: "gsi14k-7"
    })(["text-align:center;font-size:16px;line-height:24px;text-align:center;font-feature-settings:'liga' off;color:", ";"], function (props) {
      return props.theme.color.neutral.v500;
    });

    exports.DeliveryPickupLocation = DeliveryPickupLocation;

    var LocationText = _styledComponents.default.div.withConfig({
      displayName: "LocationText",
      componentId: "gsi14k-8"
    })(["font-weight:bold;font-size:16px;line-height:18px;text-align:center;font-feature-settings:'liga' off;color:", ";margin-top:4px;"], function (props) {
      return props.theme.color.primary.v600;
    });

    exports.LocationText = LocationText;

    var LearnMoreButtonWrapper = _styledComponents.default.a.withConfig({
      displayName: "LearnMoreButtonWrapper",
      componentId: "gsi14k-9"
    })(["display:flex;justify-content:center;font-size:14px;line-height:16px;margin-top:24px;margin-bottom:40px;&:hover{text-decoration:none;}"]);

    exports.LearnMoreButtonWrapper = LearnMoreButtonWrapper;

    var LineBreaker = _styledComponents.default.div.withConfig({
      displayName: "LineBreaker",
      componentId: "gsi14k-10"
    })(["width:100%;height:1px;background:", ";align-self:center;margin-top:24px;margin-bottom:16px;"], function (props) {
      return props.theme.color.neutral.v300;
    });

    exports.LineBreaker = LineBreaker;

    var DeliveryCardCaption = _styledComponents.default.div.withConfig({
      displayName: "DeliveryCardCaption",
      componentId: "gsi14k-11"
    })(["font-size:14px;line-height:20px;text-align:center;color:", ";position:relative;margin-top:15px;margin-bottom:20px;@media (min-width:", "px){position:absolute;width:50%;bottom:0;margin:0;}"], function (props) {
      return props.theme.color.neutral.v500;
    }, function (props) {
      return props.theme.breakpoint.md;
    });

    exports.DeliveryCardCaption = DeliveryCardCaption;

    var UserlocationTextWrapper = _styledComponents.default.div.withConfig({
      displayName: "UserlocationTextWrapper",
      componentId: "gsi14k-12"
    })(["font-size:16px;line-height:24px;font-feature-settings:'liga' off;color:", ";text-align:center;margin-bottom:32px;@media (min-width:", "px){margin-bottom:40px;}"], function (props) {
      return props.theme.color.neutral.v500;
    }, function (props) {
      return props.theme.breakpoint.md;
    });

    exports.UserlocationTextWrapper = UserlocationTextWrapper;

    var UserlocationText = _styledComponents.default.span.withConfig({
      displayName: "UserlocationText",
      componentId: "gsi14k-13"
    })(["color:", ";text-decoration:underline;cursor:pointer;"], function (props) {
      return props.theme.color.primary.v200;
    });

    exports.UserlocationText = UserlocationText;
    var LoadingSpinner = (0, _styledComponents.default)(_showroomSpinner.default).withConfig({
      displayName: "LoadingSpinner",
      componentId: "gsi14k-14"
    })(["div:first-child{margin-right:0;}"]);
    exports.LoadingSpinner = LoadingSpinner;
    /***/
  },

  /***/
  "./src/DeliveryOrPickup.tsx":
  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;

    var _react = _interopRequireWildcard(__webpack_require__("react"));

    var _axios = _interopRequireDefault(__webpack_require__("axios"));

    var _showroomModal = _interopRequireDefault(__webpack_require__("@carvana/showroom-modal"));

    var _DeliveryCard = _interopRequireDefault(__webpack_require__("./src/DeliveryCard.js"));

    var _PickupCard = _interopRequireDefault(__webpack_require__("./src/PickupCard.js"));

    var _PencilIcon = _interopRequireDefault(__webpack_require__("./icons/PencilIcon.js"));

    var _GeoLocationModal = _interopRequireDefault(__webpack_require__("./src/GeoLocationModal.js"));

    var _DeliveryOrPickup = __webpack_require__("./src/DeliveryOrPickup.styles.tsx");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _getRequireWildcardCache() {
      if (typeof WeakMap !== "function") return null;
      var cache = new WeakMap();

      _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
      };

      return cache;
    }

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      }

      if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
          default: obj
        };
      }

      var cache = _getRequireWildcardCache();

      if (cache && cache.has(obj)) {
        return cache.get(obj);
      }

      var newObj = {};
      var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

          if (desc && (desc.get || desc.set)) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }

      newObj.default = obj;

      if (cache) {
        cache.set(obj, newObj);
      }

      return newObj;
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    var DeliveryOrPickup = function DeliveryOrPickup(_ref) {
      var className = _ref.className,
          env = _ref.env,
          userAccessToken = _ref.userAccessToken,
          cb = _ref.cb,
          _ref$showCaption = _ref.showCaption,
          showCaption = _ref$showCaption === void 0 ? true : _ref$showCaption,
          data = _ref.data,
          restProps = _objectWithoutPropertiesLoose(_ref, ["className", "env", "userAccessToken", "cb", "showCaption", "data"]);

      var _useState = (0, _react.useState)({}),
          deliveryAndPickupDetails = _useState[0],
          setDeliveryAndPickupDetails = _useState[1];

      var _useState2 = (0, _react.useState)(false),
          isFetchingDeliveryAndPickupDetails = _useState2[0],
          setIsFetchingDeliveryAndPickupDetails = _useState2[1];

      var _useState3 = (0, _react.useState)(false),
          hasSoonestPickupAvailable = _useState3[0],
          setHasSoonestPickupAvailable = _useState3[1];

      var _useState4 = (0, _react.useState)(false),
          isDeliveryAndPickupDetailsFetched = _useState4[0],
          setIsDeliveryAndPickupDetailsFetched = _useState4[1];

      var _useState5 = (0, _react.useState)(false),
          openModal = _useState5[0],
          setOpenModal = _useState5[1];

      var userLocation = deliveryAndPickupDetails.userLocation,
          soonestDeliveryAvailable = deliveryAndPickupDetails.soonestDeliveryAvailable;

      var _ref2 = soonestDeliveryAvailable || false,
          isThirdPartyDelivery = _ref2.isThirdPartyDelivery;

      var getBaseUrl = function getBaseUrl(environment) {
        switch (environment) {
          case 'development':
            return 'https://apik.zagforward.com';

          case 'test':
            return 'https://apik.carvanatech.com';

          case 'uat':
            return 'https://apik.cvuat.com';

          case 'production':
            return 'https://apik.carvana.io';

          default:
            return 'https://apik.carvana.io';
        }
      };

      var toggleModal = function toggleModal() {
        if (openModal && cb) cb(deliveryAndPickupDetails);
        setOpenModal(!openModal);
      };

      (0, _react.useEffect)(function () {
        setIsFetchingDeliveryAndPickupDetails(true);

        if (data) {
          setDeliveryAndPickupDetails(data);
          setIsDeliveryAndPickupDetailsFetched(true);
          setHasSoonestPickupAvailable(data.soonestPickupAvailable !== null || false);
          setIsFetchingDeliveryAndPickupDetails(false);
        } else {
          _axios.default.get(getBaseUrl(env) + "/core/about-api/api/v1/getDeliveryAndPickupDetails", {
            timeout: 3500,
            headers: {
              authorization: "Bearer " + (userAccessToken || '')
            }
          }).then(function (response) {
            setDeliveryAndPickupDetails(response.data);
            setIsDeliveryAndPickupDetailsFetched(true);
            setHasSoonestPickupAvailable(response.data.soonestPickupAvailable !== null || false);
            setIsFetchingDeliveryAndPickupDetails(false);
          }).catch(function (error) {
            console.log(error);
            setIsDeliveryAndPickupDetailsFetched(false);
            setIsFetchingDeliveryAndPickupDetails(false);
          });
        }
      }, []);

      var getDeliveryCaption = function getDeliveryCaption() {
        if (!showCaption) return null;

        if (isThirdPartyDelivery) {
          return /*#__PURE__*/_react.default.createElement("span", null, "A non-refundable transportation cost may apply");
        }

        if (isDeliveryAndPickupDetailsFetched) {
          return /*#__PURE__*/_react.default.createElement("span", null, "You might be eligible for delivery");
        }

        return '';
      };

      return /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryOrPickupWrapper, _extends({
        className: className
      }, restProps), userLocation ? /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.UserlocationTextWrapper, {
        onClick: toggleModal
      }, "Your location:", ' ', /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.UserlocationText, null, userLocation.city, ", ", userLocation.state, " ", /*#__PURE__*/_react.default.createElement(_PencilIcon.default, null))) : /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.UserlocationTextWrapper, {
        onClick: toggleModal
      }, "Your location:", ' ', /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.UserlocationText, null, "Enter your zipcode ", /*#__PURE__*/_react.default.createElement(_PencilIcon.default, null))), /*#__PURE__*/_react.default.createElement(_showroomModal.default, {
        headerText: "DELIVERY OR PICKUP",
        closeModal: toggleModal,
        isOpen: openModal,
        disableBackdropClick: true
      }, /*#__PURE__*/_react.default.createElement(_GeoLocationModal.default, {
        isFetchingDeliveryAndPickupDetails: isFetchingDeliveryAndPickupDetails,
        setIsFetchingDeliveryAndPickupDetails: setIsFetchingDeliveryAndPickupDetails,
        isDeliveryAndPickupDetailsFetched: isDeliveryAndPickupDetailsFetched,
        setIsDeliveryAndPickupDetailsFetched: setIsDeliveryAndPickupDetailsFetched,
        hasSoonestPickupAvailable: hasSoonestPickupAvailable,
        deliveryAndPickupDetails: deliveryAndPickupDetails,
        setDeliveryAndPickupDetails: setDeliveryAndPickupDetails,
        setHasSoonestPickupAvailable: setHasSoonestPickupAvailable,
        env: getBaseUrl(env),
        userAccessToken: userAccessToken
      })), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupCardContainer, null, /*#__PURE__*/_react.default.createElement(_DeliveryCard.default, {
        deliveryAndPickupDetails: deliveryAndPickupDetails,
        isFetchingDeliveryAndPickupDetails: isFetchingDeliveryAndPickupDetails,
        env: env
      }), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryCardCaption, null, getDeliveryCaption()), /*#__PURE__*/_react.default.createElement(_PickupCard.default, {
        isFetchingDeliveryAndPickupDetails: isFetchingDeliveryAndPickupDetails,
        hasSoonestPickupAvailable: hasSoonestPickupAvailable,
        deliveryAndPickupDetails: deliveryAndPickupDetails,
        env: env
      })));
    };

    var _default = DeliveryOrPickup;
    exports.default = _default;
    /***/
  },

  /***/
  "./src/GeoLocationModal.js":
  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;

    var _react = _interopRequireWildcard(__webpack_require__("react"));

    var _ZipCode = _interopRequireWildcard(__webpack_require__("@carvana/showroom-forms/Input/ZipCode"));

    var _axios = _interopRequireDefault(__webpack_require__("axios"));

    var Yup = _interopRequireWildcard(__webpack_require__("yup"));

    var _formik = __webpack_require__("formik");

    var _fecha = _interopRequireDefault(__webpack_require__("fecha"));

    var _LocationIcon = _interopRequireDefault(__webpack_require__("./icons/LocationIcon.js"));

    var _GeoLocationModal = __webpack_require__("./src/GeoLocationModal.styles.js");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _getRequireWildcardCache() {
      if (typeof WeakMap !== "function") return null;
      var cache = new WeakMap();

      _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
      };

      return cache;
    }

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      }

      if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
          default: obj
        };
      }

      var cache = _getRequireWildcardCache();

      if (cache && cache.has(obj)) {
        return cache.get(obj);
      }

      var newObj = {};
      var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

          if (desc && (desc.get || desc.set)) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }

      newObj.default = obj;

      if (cache) {
        cache.set(obj, newObj);
      }

      return newObj;
    }

    var GeoLocationModal = function GeoLocationModal(_ref) {
      var deliveryAndPickupDetails = _ref.deliveryAndPickupDetails,
          setDeliveryAndPickupDetails = _ref.setDeliveryAndPickupDetails,
          isFetchingDeliveryAndPickupDetails = _ref.isFetchingDeliveryAndPickupDetails,
          setIsFetchingDeliveryAndPickupDetails = _ref.setIsFetchingDeliveryAndPickupDetails,
          isDeliveryAndPickupDetailsFetched = _ref.isDeliveryAndPickupDetailsFetched,
          setIsDeliveryAndPickupDetailsFetched = _ref.setIsDeliveryAndPickupDetailsFetched,
          setHasSoonestPickupAvailable = _ref.setHasSoonestPickupAvailable,
          hasSoonestPickupAvailable = _ref.hasSoonestPickupAvailable,
          env = _ref.env,
          userAccessToken = _ref.userAccessToken;

      var _useState = (0, _react.useState)(true),
          isZipCodeValid = _useState[0],
          setIsZipCodeValid = _useState[1];

      var validationSchema = Yup.object().shape({
        zip5: _ZipCode.schema
      });
      var userLocation = deliveryAndPickupDetails.userLocation,
          soonestDeliveryAvailable = deliveryAndPickupDetails.soonestDeliveryAvailable,
          soonestPickupAvailable = deliveryAndPickupDetails.soonestPickupAvailable;

      var _ref2 = soonestDeliveryAvailable || false,
          isThirdPartyDelivery = _ref2.isThirdPartyDelivery;

      return /*#__PURE__*/_react.default.createElement(_GeoLocationModal.GeoLocationModalWrapper, null, /*#__PURE__*/_react.default.createElement(_GeoLocationModal.GetYourVehicleSection, null, /*#__PURE__*/_react.default.createElement(_GeoLocationModal.GetYourVehicleTitle, null, "Get your vehicle how you want"), /*#__PURE__*/_react.default.createElement(_GeoLocationModal.GetYourVehicleDescription, null, "We'll bring the car straight to your driveway, or you can experience one of our Vehicle Vending Machines."), /*#__PURE__*/_react.default.createElement(_GeoLocationModal.ZipcodeWrapper, null, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
        initialValues: {
          zip5: ''
        },
        validationSchema: validationSchema,
        onSubmit: function onSubmit(values) {
          setIsFetchingDeliveryAndPickupDetails(true);
          setHasSoonestPickupAvailable(false);

          _axios.default.get(env + "/core/about-api/api/v1/getDeliveryAndPickupDetails?zip5=" + values.zip5, {
            timeout: 3000,
            headers: {
              authorization: "Bearer " + (userAccessToken || '')
            }
          }).then(function (response) {
            setDeliveryAndPickupDetails(response.data);
            setIsFetchingDeliveryAndPickupDetails(false);
            setIsDeliveryAndPickupDetailsFetched(true);
            setHasSoonestPickupAvailable(response.data.soonestPickupAvailable !== null);
            setIsZipCodeValid(true);
          }).catch(function (error) {
            console.log(error);
            setIsFetchingDeliveryAndPickupDetails(false);
            setIsDeliveryAndPickupDetailsFetched(false);
            setHasSoonestPickupAvailable(deliveryAndPickupDetails.soonestPickupAvailable !== null);
            setIsZipCodeValid(false);
          });
        },
        render: function render(_ref3) {
          var touched = _ref3.touched,
              handleChange = _ref3.handleChange,
              handleBlur = _ref3.handleBlur,
              values = _ref3.values,
              errors = _ref3.errors;
          var zipCodeErrorMessage = !isZipCodeValid && 'Invalid zipcode';
          return /*#__PURE__*/_react.default.createElement(_GeoLocationModal.ZipCodeForm, null, /*#__PURE__*/_react.default.createElement(_ZipCode.default, {
            id: "zipcode-input",
            onBlur: handleBlur,
            onChange: handleChange,
            touched: touched.zip5,
            error: (errors.zip5, zipCodeErrorMessage),
            value: values.zip5,
            name: "zip5",
            width: 150,
            mode: "dark"
          }), /*#__PURE__*/_react.default.createElement(_GeoLocationModal.ZipCodeButton, {
            type: "submit"
          }, "GO"));
        }
      })), isDeliveryAndPickupDetailsFetched && !isFetchingDeliveryAndPickupDetails && /*#__PURE__*/_react.default.createElement(_GeoLocationModal.UserLocationWrapper, null, /*#__PURE__*/_react.default.createElement(_LocationIcon.default, null), " Location:", ' ', /*#__PURE__*/_react.default.createElement(_GeoLocationModal.UserLocationText, null, userLocation.city, ", ", userLocation.state))), (isDeliveryAndPickupDetailsFetched || isFetchingDeliveryAndPickupDetails) && /*#__PURE__*/_react.default.createElement(_GeoLocationModal.DeliveryPickupSection, null, isFetchingDeliveryAndPickupDetails ? /*#__PURE__*/_react.default.createElement(_GeoLocationModal.LoadingSpinner, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_GeoLocationModal.DeliveryPickupBlock, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_GeoLocationModal.DeliveryPickupTitle, null, "DELIVERY"), isThirdPartyDelivery ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_GeoLocationModal.DeliveryPickupDescription, null, "We deliver in 5-15 business days."), /*#__PURE__*/_react.default.createElement(_GeoLocationModal.ThirdPartyDeliveryText, null, /*#__PURE__*/_react.default.createElement("span", null, "*"), "out of market", /*#__PURE__*/_react.default.createElement("br", null), "transportation charge may apply")) : /*#__PURE__*/_react.default.createElement(_GeoLocationModal.DeliveryPickupDescription, null, "You could have your vehicle delivered as soon as", ' ', /*#__PURE__*/_react.default.createElement("span", null, _fecha.default.format(new Date(soonestDeliveryAvailable.date), 'dddd, MMM D'), "."))), /*#__PURE__*/_react.default.createElement("a", {
        href: "/faq/delret-happens"
      }, "Learn More")), /*#__PURE__*/_react.default.createElement(_GeoLocationModal.DeliveryPickupBlock, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_GeoLocationModal.DeliveryPickupTitle, null, "PICK UP"), /*#__PURE__*/_react.default.createElement(_GeoLocationModal.DeliveryPickupDescription, null, hasSoonestPickupAvailable ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "The nearest location is", ' ', /*#__PURE__*/_react.default.createElement("span", null, soonestPickupAvailable.city, ' ', soonestPickupAvailable.state), ' ', "(", soonestPickupAvailable.drivingMiles, " miles away). Pick up as soon as", ' ', /*#__PURE__*/_react.default.createElement("span", null, _fecha.default.format(new Date(soonestPickupAvailable.date), 'dddd, MMM D'), ".")) : 'Pick up is not available at this location')), /*#__PURE__*/_react.default.createElement("a", {
        href: "/vending-machine"
      }, "Learn More")))));
    };

    var _default = GeoLocationModal;
    exports.default = _default;
    /***/
  },

  /***/
  "./src/GeoLocationModal.styles.js":
  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.LoadingSpinner = exports.ZipCodeForm = exports.ZipCodeButton = exports.ZipcodeWrapper = exports.ThirdPartyDeliveryText = exports.DeliveryPickupDescription = exports.DeliveryPickupTitle = exports.DeliveryPickupBlock = exports.DeliveryPickupSection = exports.UserLocationText = exports.UserLocationWrapper = exports.GetYourVehicleDescription = exports.GetYourVehicleTitle = exports.GetYourVehicleSection = exports.GeoLocationModalWrapper = void 0;

    var _styledComponents = _interopRequireDefault(__webpack_require__("styled-components"));

    var _showroomSpinner = _interopRequireDefault(__webpack_require__("@carvana/showroom-spinner"));

    var _Primary = _interopRequireDefault(__webpack_require__("@carvana/showroom-forms/Button/Primary"));

    var _formik = __webpack_require__("formik");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var GeoLocationModalWrapper = _styledComponents.default.div.withConfig({
      displayName: "GeoLocationModalWrapper",
      componentId: "vv17yk-0"
    })(["text-align:center;"]);

    exports.GeoLocationModalWrapper = GeoLocationModalWrapper;

    var GetYourVehicleSection = _styledComponents.default.div.withConfig({
      displayName: "GetYourVehicleSection",
      componentId: "vv17yk-1"
    })(["padding:30px 20px;background:", ";color:", ";border-bottom:1px solid ", ";"], function (props) {
      return props.theme.color.neutral.v200;
    }, function (props) {
      return props.theme.color.primary.v600;
    }, function (props) {
      return props.theme.color.neutral.v300;
    });

    exports.GetYourVehicleSection = GetYourVehicleSection;

    var GetYourVehicleTitle = _styledComponents.default.div.withConfig({
      displayName: "GetYourVehicleTitle",
      componentId: "vv17yk-2"
    })(["margin:0 auto;font-size:20px;font-weight:700;color:", ";line-height:22px;text-transform:uppercase;padding:0px;max-width:200px;@media (min-width:", "px){max-width:400px;}"], function (props) {
      return props.theme.color.primary.v600;
    }, function (props) {
      return props.theme.breakpoint.md;
    });

    exports.GetYourVehicleTitle = GetYourVehicleTitle;

    var GetYourVehicleDescription = _styledComponents.default.div.withConfig({
      displayName: "GetYourVehicleDescription",
      componentId: "vv17yk-3"
    })(["margin:16px auto;color:", ";font-size:16px;font-weight:400;@media (min-width:", "px){max-width:475px;}"], function (props) {
      return props.theme.color.neutral.v500;
    }, function (props) {
      return props.theme.breakpoint.md;
    });

    exports.GetYourVehicleDescription = GetYourVehicleDescription;

    var UserLocationWrapper = _styledComponents.default.div.withConfig({
      displayName: "UserLocationWrapper",
      componentId: "vv17yk-4"
    })(["color:", ";margin:0px 0px 0px 3px;font-size:16px;font-weight:bold;"], function (props) {
      return props.theme.color.neutral.v400;
    });

    exports.UserLocationWrapper = UserLocationWrapper;

    var UserLocationText = _styledComponents.default.span.withConfig({
      displayName: "UserLocationText",
      componentId: "vv17yk-5"
    })(["text-transform:uppercase;color:", ";"], function (props) {
      return props.theme.color.primary.v600;
    });

    exports.UserLocationText = UserLocationText;

    var DeliveryPickupSection = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupSection",
      componentId: "vv17yk-6"
    })(["display:flex;justify-content:center;align-items:center;flex-direction:column;padding:30px 0;background:", ";border-bottom:1px solid ", ";@media (min-width:", "px){flex-direction:row;align-items:normal;}"], function (props) {
      return props.theme.color.neutral.v100;
    }, function (props) {
      return props.theme.color.neutral.v300;
    }, function (props) {
      return props.theme.breakpoint.md;
    });

    exports.DeliveryPickupSection = DeliveryPickupSection;

    var DeliveryPickupBlock = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupBlock",
      componentId: "vv17yk-7"
    })(["display:flex;flex-direction:column;justify-content:space-between;max-width:270px;min-height:100px;a{display:block;font-size:16px;color:", ";text-decoration:none;margin-top:15px;}&:first-child{padding-bottom:30px;border-bottom:1px solid ", ";}&:last-child{padding-top:30px;}@media (min-width:", "px){max-width:none;&:first-child{padding-bottom:0;border-right:1px solid ", ";border-bottom:none;width:50%;}&:last-child{padding-top:0;width:50%;}padding:0 30px;}"], function (props) {
      return props.theme.color.primary.v200;
    }, function (props) {
      return props.theme.color.neutral.v300;
    }, function (props) {
      return props.theme.breakpoint.md;
    }, function (props) {
      return props.theme.color.neutral.v300;
    });

    exports.DeliveryPickupBlock = DeliveryPickupBlock;

    var DeliveryPickupTitle = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupTitle",
      componentId: "vv17yk-8"
    })(["font-size:20px;font-weight:700;color:", ";margin:0px;text-transform:uppercase;"], function (props) {
      return props.theme.color.primary.v600;
    });

    exports.DeliveryPickupTitle = DeliveryPickupTitle;

    var DeliveryPickupDescription = _styledComponents.default.div.withConfig({
      displayName: "DeliveryPickupDescription",
      componentId: "vv17yk-9"
    })(["padding:0px;font-size:14px;color:", ";font-weight:400;margin-top:5px;span{font-weight:bold;}"], function (props) {
      return props.theme.color.neutral.v500;
    });

    exports.DeliveryPickupDescription = DeliveryPickupDescription;

    var ThirdPartyDeliveryText = _styledComponents.default.div.withConfig({
      displayName: "ThirdPartyDeliveryText",
      componentId: "vv17yk-10"
    })(["color:", ";font-size:12px;font-weight:700;text-transform:uppercase;margin-top:20px;span{font-size:14px;font-weight:400;color:", ";}"], function (props) {
      return props.theme.color.neutral.v500;
    }, function (props) {
      return props.theme.color.primary.v200;
    });

    exports.ThirdPartyDeliveryText = ThirdPartyDeliveryText;

    var ZipcodeWrapper = _styledComponents.default.div.withConfig({
      displayName: "ZipcodeWrapper",
      componentId: "vv17yk-11"
    })(["margin-bottom:20px;"]);

    exports.ZipcodeWrapper = ZipcodeWrapper;
    var ZipCodeButton = (0, _styledComponents.default)(_Primary.default).withConfig({
      displayName: "ZipCodeButton",
      componentId: "vv17yk-12"
    })(["margin-left:10px;height:56px;min-width:56px;"]);
    exports.ZipCodeButton = ZipCodeButton;
    var ZipCodeForm = (0, _styledComponents.default)(_formik.Form).withConfig({
      displayName: "ZipCodeForm",
      componentId: "vv17yk-13"
    })(["display:flex;justify-content:center;"]);
    exports.ZipCodeForm = ZipCodeForm;
    var LoadingSpinner = (0, _styledComponents.default)(_showroomSpinner.default).withConfig({
      displayName: "LoadingSpinner",
      componentId: "vv17yk-14"
    })(["padding:10px 0;"]);
    exports.LoadingSpinner = LoadingSpinner;
    /***/
  },

  /***/
  "./src/PickupCard.js":
  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;

    var _react = _interopRequireDefault(__webpack_require__("react"));

    var _Secondary = _interopRequireDefault(__webpack_require__("@carvana/showroom-forms/Button/Secondary"));

    var _fecha = _interopRequireDefault(__webpack_require__("fecha"));

    var _DeliveryOrPickup = __webpack_require__("./src/DeliveryOrPickup.styles.tsx");

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var PickupCardSection = function PickupCardSection(_ref) {
      var isFetchingDeliveryAndPickupDetails = _ref.isFetchingDeliveryAndPickupDetails,
          deliveryAndPickupDetails = _ref.deliveryAndPickupDetails,
          hasSoonestPickupAvailable = _ref.hasSoonestPickupAvailable,
          env = _ref.env;

      var getFastlyBaseUrl = function getFastlyBaseUrl(environment) {
        switch (environment) {
          case 'development':
            return 'https://assets.fastly.zagforward.com';

          case 'test':
            return 'https://assets.fastly.carvanatech.com';

          case 'uat':
            return 'https://resources.fastly.cvuat.com';

          case 'production':
            return 'https://assets.fastly.carvana.io';

          default:
            return 'https://assets.fastly.carvana.io';
        }
      };

      var soonestPickupAvailable = deliveryAndPickupDetails.soonestPickupAvailable;
      var CDN_BASE_URL = "" + getFastlyBaseUrl(env);

      var renderPickupWithData = function renderPickupWithData() {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupHeader, null, "Pickup as soon as:"), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupTimeWrapper, null, /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupImage, {
          src: CDN_BASE_URL + "/about-assets/pickup.png?format=jpeg&auto=webp"
        }), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupDate, null, /*#__PURE__*/_react.default.createElement("div", null, _fecha.default.format(new Date(soonestPickupAvailable.date), 'MMMM')), /*#__PURE__*/_react.default.createElement("div", null, _fecha.default.format(new Date(soonestPickupAvailable.date), 'D')))), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LineBreaker, null), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupLocation, null, /*#__PURE__*/_react.default.createElement("span", null, "Closest pickup location:"), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LocationText, null, soonestPickupAvailable.city, ", ", soonestPickupAvailable.state)), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LearnMoreButtonWrapper, {
          href: "/vending-machine"
        }, /*#__PURE__*/_react.default.createElement(_Secondary.default, {
          size: "medium"
        }, "Learn More")));
      };

      var renderPickupWithSadState = function renderPickupWithSadState() {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupTimeWrapper, {
          className: "is-sad-state"
        }, /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupImage, {
          src: CDN_BASE_URL + "/about-assets/pickup.png?format=jpeg&auto=webp",
          className: "is-sad-state"
        }), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LineBreaker, null), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupHeader, {
          className: "is-sad-state"
        }, "Pickup"), /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LearnMoreButtonWrapper, {
          href: "/vending-machine"
        }, /*#__PURE__*/_react.default.createElement(_Secondary.default, {
          size: "medium"
        }, "Learn More"))));
      };

      var renderPickupCard = function renderPickupCard() {
        if (hasSoonestPickupAvailable && soonestPickupAvailable !== undefined) {
          return renderPickupWithData();
        }

        return renderPickupWithSadState();
      };

      return /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.DeliveryPickupCardWrapper, null, isFetchingDeliveryAndPickupDetails ? /*#__PURE__*/_react.default.createElement(_DeliveryOrPickup.LoadingSpinner, {
        isLarge: true
      }) : renderPickupCard());
    };

    var _default = PickupCardSection;
    exports.default = _default;
    /***/
  },

  /***/
  "./src/index.js":
  /***/
  function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;

    var _DeliveryOrPickup = _interopRequireDefault(__webpack_require__("./src/DeliveryOrPickup.tsx"));

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var _default = _DeliveryOrPickup.default;
    exports.default = _default;
    /***/
  },

  /***/
  "@carvana/showroom-forms/Button/Primary":
  /***/
  function (module, exports) {
    module.exports = require("@carvana/showroom-forms/Button/Primary");
    /***/
  },

  /***/
  "@carvana/showroom-forms/Button/Secondary":
  /***/
  function (module, exports) {
    module.exports = require("@carvana/showroom-forms/Button/Secondary");
    /***/
  },

  /***/
  "@carvana/showroom-forms/Input/ZipCode":
  /***/
  function (module, exports) {
    module.exports = require("@carvana/showroom-forms/Input/ZipCode");
    /***/
  },

  /***/
  "@carvana/showroom-modal":
  /***/
  function (module, exports) {
    module.exports = require("@carvana/showroom-modal");
    /***/
  },

  /***/
  "@carvana/showroom-spinner":
  /***/
  function (module, exports) {
    module.exports = require("@carvana/showroom-spinner");
    /***/
  },

  /***/
  "axios":
  /***/
  function (module, exports) {
    module.exports = require("axios");
    /***/
  },

  /***/
  "fecha":
  /***/
  function (module, exports) {
    module.exports = require("fecha");
    /***/
  },

  /***/
  "formik":
  /***/
  function (module, exports) {
    module.exports = require("formik");
    /***/
  },

  /***/
  "react":
  /***/
  function (module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  "styled-components":
  /***/
  function (module, exports) {
    module.exports = require("styled-components");
    /***/
  },

  /***/
  "yup":
  /***/
  function (module, exports) {
    module.exports = require("yup");
    /***/
  }
  /******/

});